<template>
  <div class="box">
    <div class="top" @click="backPage">
      <img src="../../assets/images/wap/goback.png" alt="">
      <span>晒单</span>

    </div>
    <div class="content">
      <!-- <div class="content-top">
          <div>晒单订单号</div>

        <div class="order">
          <div class="orderno">#123456（盈亏$80）</div>
        <img src="../../assets/images/gifts/right.png" alt="">

        </div>
      </div> -->
      <el-input type="textarea" placeholder="在直播间晒出你的交易成果，与老师和同学们分享战况吧~ 别忘记一键同步到问答广场，与其他投资者交流操作心得~"
        v-model="form.content" :rows="10" maxlength="500" show-word-limit style="height: 200px;">
      </el-input>
      <div class="uploads">

        <el-upload class="avatar-uploader" v-if="fileList.length<3" :action="actionUrl" :limit="4" multiple :show-file-list="false"
          :on-exceed="handleExceed" :on-success="afterRead" :before-upload="handleBeforeUpload">

          <i class="el-icon-plus avatar-uploader-icon" ></i>
        </el-upload>

        <div class="filefelx">
          <div class="filelist" v-for="(item, index) in fileList" :key="index">
            <img class="close" src="../../assets/images/wap/closer.png" @click.stop="handleDelete(index)" alt="">

            <img class="files" :src="item" alt="">
          </div>
        </div>

      </div>
      <div class="notice">
        发布内容涉及个人隐私及个人资料，将不会予以通过
      </div>
    </div>
    <div class="submit" @click="submitPrint">
      一键晒单
    </div>

  </div>
</template>

<script>
import { time } from 'echarts';
import config from '../../config/index'
import { type } from 'jquery';
import { CreatePrintOutQuestion } from '../../api/home'
import { options } from 'less';

import { postUploadImgCms } from '@/apis/hdtime'
export default {
  name: 'wapTab',
  data() {
    return {
      textarea: '',
   
      form: {
        "businessPlatform": 4,
        "content": "",
        "imgUrls": [
          // "https://mcliveroot.oss-accelerate.aliyuncs.com/huiadmin/images/hui/20241225113522547.jpg?Expires=3627257722&OSSAccessKeyId=LTAI5tPmA5wBPs6DVUUtaZv5&Signature=AodS%2FYRMdzxKzmcEdVBxDBcOq%2Bo%3D"
        ],
        "account": 0,
        "name": "string",
        "questionType": 3,
        "isNeedAudit": true,
        "orderId": 0,
        "avatarUrl": "string"

      },

      imgList:[],
      fileList: [],
      // 是否显示文件上传弹窗
      visible: false,
   
      action: 'action',
      actionUrl:'https://www.rlcproltd.net/cmsApi/File/Upload'
    }
  },
  props: {
    playTime: {
      type: String,
      default: '00:00'
    }
  },
  created() {
    console.log('个人数据-------------', this.$store.state.login.userInfo)
    // 传给App.vue,不展示tabbar
    this.$emit('controlShow', true);
  },
  computed: {
    // 个人信息
    userInfo() {
      return this.$store.state.login.userInfo
    },
  },
  methods: {
   
    // 上传成功
    afterRead(file) {
     
      this.fileList.push(file.result.returnUrl)
    },
     handleBeforeUpload(file) {
    
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`只允许上传3个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },
    
    // 删除文件
    handleDelete(index) {
      this.fileList.splice(index, 1);
    },

    // 返回直播间
    backPage() {
      this.$router.back()
      // this.$router.push({
      //   name: 'classRoomWap'
      // })
    },
    // 提交晒单数据
    submitPrint() {
      if (!this.form.content) {
        this.$message({
          type: 'error',
          message: '请输入内容！'
        })
        return false
      }
      if (this.fileList.length == 0) {
        this.$message({
          type: 'error',
          message: '请上传图片！'
        })
        return false
      }
      const options = {
        "businessPlatform": 4,
        "content": this.form.content,
        "imgUrls": this.fileList,
        "account": this.userInfo.mtaccr,
        "name": this.userInfo.nick,
        "questionType": 3,
        "isNeedAudit": true,
        "orderId": 0,
        "avatarUrl": this.userInfo.avatar,
        'BusinessPlatform':4

      }
      CreatePrintOutQuestion(options).then(res => {
        console.log(res)
        if (res.success) {
          this.$message({
            type: 'success',
            message: '晒单成功！',
            duration:1000,
            showClose:true
          })
          this.$router.push({
            name: 'classRoomWap'
          })
        }
      })
    },
    // 上传头像成功
    handleAvatarSuccess(res, file) {
      if (file.response.Status == 0) {
        if (this.form.imgUrls.length >= 3) {
          this.$message.error("最多只能上传3张图片!");
          return
        }
        this.form.imgUrls.push(file.response.url);
        this.handlePrivateMessageSend()
      } else {
        this.$message.error("图片上传失败!");
      }
    },
    // 上传头像之前
    beforeAvatarUpload(file) {
      const isJPG = file.type == "image/jpeg" || "image/png" || "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("请上传正确图片格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

  }
}
</script>

<style lang="less" scoped>
.box {
  width: 100%;

  background: rgba(238, 238, 238, 0.4);

  height: 100%;

  .top {
    height: 45px;
    background-color: #fff;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    text-align: center;
    padding: 11px 0px 11px 20px;
    font-size: 18px;
    line-height: 25px;
    color: #000;
    font-weight: 700;
    text-align: center;

    img {
      width: 8px;
      height: 16px;
      margin-right: 36%;
    }
  }

  span {
    width: 90px;
    text-align: center;
    font-size: 15px;
  }

}

.content {
  padding: 12px 16px 0;
  font-size: 13px;
  line-height: 18px;
  color: #2C323B;

  .content-top {
    width: 100%;
    height: 44px;
    border-radius: 8px;
    background: #fff;
    font-size: 13px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 24px;
    margin-bottom: 12px;
    box-sizing: border-box;

    img {
      width: 10px;
      height: 10px;
    }
  }

  .order {
    display: flex;
    align-items: center;
  }

  .orderno {
    color: #2C3EB9;

  }
}

.uploads {
  margin-top: 40px;
  display: flex;
 
  &-box{
    width: 106px;
    height: 106px;
    background: #fff;
  }
}

.notice {
  font-size: 13px;
  line-height: 18px;
  color: #FE2C55;

}

.submit {
  width: 90%;
  height: 46px;
  background: #EE2547;
  font-size: 15px;
  line-height: 22px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  position: fixed;
  bottom: 30px;
  left: 22px;
}

// 上传图片
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 106px;
  height: 106px;

}
.filefelx{
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  
}
.filelist{
width: 100px;
  height: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
  .files{
    width: 100%;
    height: 100%;

  }
  .close{
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
  }
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106px;
  height: 106px;
  line-height: 106px;
  text-align: center;
  background: #fff;
  border-radius: 12px;

}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>